export default __webpack_public_path__ + "static/media/akar-icons_arrow-down.8f02aa5c.svg";